var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
// Can Support Workers Interface
OCS.Interfaces.CSWorkers = {
    worker_support: true,
    workers: {},
    booting_workers: [],
    queued_workers: [],
    // Actions
    init_workers: function () {
        this.bound_methods.on_worker_idle = this.on_worker_idle.bind(this);
        this.bound_methods.on_worker_online = this.on_worker_online.bind(this);
        this.bound_methods.on_worker_status_update = this.on_worker_status_update.bind(this);
        this.bound_methods.on_worker_terminated = this.on_worker_terminated.bind(this);
    },
    activate_worker: function (worker, worker_request_info) {
        if (!worker || worker.class_type !== "WorkerHandler" || !worker.set_active_request || !worker.set_active_request(worker_request_info)) {
            return false;
        }
        return true;
    },
    create_worker: function (request_info) {
        if (!request_info.path) {
            return false;
        }
        var path = request_info.path;
        if (this.booting_workers.contains(path)) {
            return false;
        }
        /* istanbul ignore if */
        if (this.options.debug) {
            console.debug('Worker Manager: Creating a new worker. ', path);
        }
        var worker = new OCS.Classes.WorkerHandler({'path': path});
        worker.addEvent(worker.options.events.worker_online, this.bound_methods.on_worker_online);
        worker.addEvent(worker.options.events.worker_status_update, this.bound_methods.on_worker_status_update);
        worker.addEvent(worker.options.events.worker_terminated, this.bound_methods.on_worker_terminated);
        this.addEvent('destroy', worker.bound_methods.destroy);
        if (request_info.msg || request_info.init_msg || request_info.msg_queue) {
            worker.set_active_request(request_info);
        }
        this.booting_workers.push(path);
        return worker;
    },
    make_worker_request: function (request) {
        var worker;
        if (request.worker_id) {
            // This is set to go to a specific worker, lets make sure its still around
            worker = this.get_worker(request.worker_id);
            // Now lets make sure the worker is either idle and accessible
            if (worker && worker.is_idle) {
                if (this.activate_worker(worker, request)) {
                    return true;
                }
            } else {
                // This worker does not exist, set to null, if the request has a path, can still make it work
                request.worker_id = null;
            }
        }
        if (request.path) {
            // This is not going to any one worker, but it has to be one of the given path that is available
            worker = this.get_idle_worker(request.path);
            if (worker && this.activate_worker(worker, request)) {
                return true;
            }
            // No worker was idle for this request, lets see if we can create one
            if (!this.is_type_full(request.path) && this.create_worker(request)) {
                return true;
            }
        }
        if (request.path || request.worker_id) {
            // We made it to here, means we need to queue this request for later
            this.queue_request(request);
        } else {
            console.warn("Request sent to worker manager with no path or worker id!", request);
        }
        return false;
    },
    register_worker: function (request_info) {
        if (request_info === null || typeof request_info !== "object" || !Object.keys(request_info).length) {
            return false;
        }
        if (!request_info.path) {
            return false;
        }
        var path = request_info.path;
        if (this.is_active_full() || this.is_type_full(path)) {
            this.queued_workers.push(request_info);
        } else {
            return this.create_worker(request_info);
        }
        return false;
    },
    terminate_worker: function (worker_id) {
        var worker_info = this.get_worker(worker_id);
        if (worker_info) {
            worker_info.destroy();
        }
    },

    // Event Listeners
    on_worker_idle: function (worker_info) {
        if (worker_info && this.get_worker(worker_info.worker_id)) {
            this.fireEvent(this.options.events.worker_available, worker_info);
        }
    },
    on_worker_online: function (worker) {
        if (worker && worker.worker_id) {
            worker.removeEvent(worker.options.events.worker_online, this.bound_methods.on_worker_online); // Remove this event so that we do not get this firing repeatedly
            worker.addEvent(worker.options.events.worker_idle, this.bound_methods.on_worker_idle); // Now we are going to listen for when the worker is idle and relay that
            this.workers[worker.worker_id] = worker;
            this.booting_workers.erase(worker.options.path);
        }
    },
    on_worker_status_check: function () {
        var ids = Object.keys(this.workers);
        var worker, i, id;
        for (i = 0; i < ids.length; i++) {
            id = ids[i];
            worker = this.get_worker(id);
            if (this.worker_status_check.contains(id)) {
                if (this.warn_worker_removal.contains(id)) {
                    console.warn('Worker Manager: Worker ' + id + ' has failed 2 status checks. Terminating!');
                    // Not heard from it, so remove it
                    worker.destroy();
                    continue;
                }
                this.warn_worker_removal.combine([id]);
                console.warn('Worker Manager: Worker ' + id + ' is being unresponsive, attempting status check 1 more time for ' + Math.floor(this.options.status_check / 1000) + ' seconds before terminating it.');
            }
            this.worker_status_check.combine([id]);
            try {
                worker.send_worker_message({'cmd': 'status'});
            } catch (e) {
                console.warn('Found a dead worker. Terminating it.', e);
                worker.destroy();
            }

        }
    },
    on_worker_status_update: function (worker) {
        this.warn_worker_removal.erase(worker.worker_id);
        this.worker_status_check.erase(worker.worker_id);
    },
    on_worker_terminated: function (worker) {
        var worker_id = worker.worker_id;
        delete this.workers[worker_id];
        if (this.queued_workers.length) {
            this.register_worker(this.queued_workers.shift());
        }
    },

    // Boolean Methods
    is_active_full: function () {
        if (this.get_num_workers() >= this.options.max_number_of_active_workers) {
            return true;
        } else {
            return false;
        }
    },
    is_type_full: function (path) {
        if (this.get_num_path_workers(path) < this.options.max_number_of_worker_type) {
            return false;
        }
        return true;
    },
    is_worker_available: function (request) {
        var worker;
        if (request.worker_id) {
            // This is set to go to a specific worker, lets make sure its still around
            worker = this.get_worker(request.worker_id);
            // Now lets make sure the worker is either idle and accessible
            if (worker) {
                if (worker.is_idle) {
                    return true;
                }
            } else {
                // This worker does not exist, set to null, if the request has a path, can still make it work
                request.worker_id = null;
            }
        }
        if (request.path) {
            // This is not going to any one worker, but it has to be one of the given path that is available
            worker = this.get_idle_worker(request.path);
            if (worker) {
                return true;
            }
            // No worker was idle for this request, maybe we can create one
            if (!this.is_type_full(request.path) && !this.booting_workers.contains(request.path)) {
                return true;
            }
        }
        return false;
    },

    // Get / Set methods
    get_num_workers: function () {
        return Object.keys(this.workers).length;
    },
    get_num_idle_workers: function () {
        var ids = Object.keys(this.workers);
        var count = 0;
        var i, worker;
        for (i = 0; i < ids.length; i++) {
            worker = this.get_worker(ids[i]);
            if (worker && worker.is_idle) {
                count++;
            }
        }
        return count;
    },
    get_num_path_workers: function (worker_path) {
        var count = 0;
        var ids = Object.keys(this.workers);
        var worker, i;
        for (i = 0; i < ids.length; i++) {
            worker = this.get_worker(ids[i]);
            if (worker.options.path === worker_path) {
                count++;
            }
        }
        return count;
    },
    get_worker: function (worker_id) {
        if (this.workers.hasOwnProperty(worker_id)) {
            return this.workers[worker_id];
        } else {
            return false;
        }
    },
    get_idle_worker: function (worker_path) {
        var ids = Object.keys(this.workers);
        var worker, i;
        for (i = 0; i < ids.length; i++) {
            worker = this.get_worker(ids[i]);
            if (worker.options.path === worker_path && worker.is_idle) {
                return worker;
            }
        }
        return false;
    },
    destroy_workers: function () {
        var worker_ids = Object.keys(this.workers);
        worker_ids.each(function (worker_id) {
            if (this.workers[worker_id]) {
                this.workers[worker_id].destroy();
            }
        }.bind(this));
        this.workers = {};
    }
};